module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title44"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429932950_tp01",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429932950_ack01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_introduction",
    attrs: {
      "href": "#/e9781429932950_itr01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Introduction")])])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429932950_p01",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part One")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Seven Motivations for Espionage")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c01",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter One")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Espionage versus Intelligence: How the United States Goes About Spying")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c02",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Two")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Ideological Commitment")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c03",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Three")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Money and Treasure")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c04",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Four")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Revenge and Score Settling")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c05",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Five")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Sex, Intimidation, and Blackmail")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c06",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Six")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Spying for Reasons of Friendship or Ethnic or Religious Solidarity")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c07",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Seven")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Spy Game for the Sake of the Game")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429932950_p02",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Two")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("America’s Spying Competence Today")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c08",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Eight")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Intelligence Failures and Politicization")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c09",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Nine")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The CIA in Transition 1991 to the Present")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c10",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Ten")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Intelligence Reform")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429932950_p03",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Three")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Spying in the Twenty-first Century")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c11",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Actionable Intelligence and the Role of Law Enforcement, the Military, and Technology")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c12",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Foreign Liaison Services and Spying Lawfully")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c13",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Updating Operational and Analytical Tradecraft")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429932950_p04",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Four")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Why Spy? Should We Do It?")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932950_c14",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Spy for the Twenty-first Century")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429932950_bm01",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Conclusion")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Can We Make Espionage Work in the Twenty-first Century?")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429932950_als01",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Also by Frederick P. Hitz")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429932950_bm02",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Notes")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781429932950_ind01",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Index")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_aboutAuthorPage",
    attrs: {
      "href": "#/e9781429932950_ata01",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("About the Author")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429932950_cop01",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a27ef6ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429932950_toc01.vue
// module id = 66
// module chunks = 0